import { Record } from "immutable";
import _ from "lodash";

// common attributes implemented by all APIv3 objects
const commonAttrs = {
  id: null,
  // qrohlf note: _permissions is a legacy format that was hacked into the
  // RSP. It is currently *exclusively* used by the RSP, and will go
  // away once the TRouteShowPage is completed. From here on out, please
  // use `permissions` and NOT `_permissions`. Note that in order to
  // correctly use `permissions`, you WILL need to handle the case where
  // permissions is null.
  _permissions: {},
  permissions: null,
};

// todo - should this be deep?
const camelCaseKeys = (obj) => _.mapKeys(obj, (v, k) => _.camelCase(k));

const snakeCaseKeys = (obj) => _.mapKeys(obj, (v, k) => _.snakeCase(k));

export const V3Record = (modelName, attrs, { fileAttrs, readOnly, writeable } = {}) => {
  const R = Record({ ...attrs, ...commonAttrs });
  R.modelName = modelName;
  R.deserialize = (fromRails) => R(camelCaseKeys(fromRails));
  R.serialize = (record, pickAttrs) => {
    let attrs;
    if (writeable) {
      attrs = _.pick(record.toJS(), writeable);
    } else {
      attrs = record.toJS();
      delete attrs.id;
      delete attrs._permissions;
      delete attrs.permissions;
      if (readOnly) {
        readOnly.forEach((attr) => {
          delete attrs[attr];
        });
      }
    }
    if (pickAttrs) {
      attrs = _.pick(attrs, pickAttrs);
    }
    let isMultiPart = false;
    if (fileAttrs) {
      fileAttrs.forEach((attr) => {
        const value = attrs[attr];
        // the backend gives us file attributes as uri strings, and we don't want to send those back.
        // if a user attaches a file for upload, it is not a string and should be included.
        if (value && typeof value === "string") {
          delete attrs[attr];
        } else if (value) {
          isMultiPart = true;
        }
      });
    }
    if (isMultiPart) {
      // if the record has files to be attached, send as a multipart/form-data request
      const body = new window.FormData();
      Object.entries(attrs).forEach(([key, value]) => {
        body.append(`${_.snakeCase(modelName)}[${_.snakeCase(key)}]`, value);
      });
      return body;
    } else {
      return { [_.snakeCase(modelName)]: snakeCaseKeys(attrs) };
    }
  };
  return R;
};
